import {ErrorDtoFactory, UploadProgressingImagesDto, UserDto} from "../../dtos";
import {Dispatch} from "redux";
import {Action as FlyerFromJpegsActions} from "../actions/flyerFromJpegsActions";
import {ActionType} from "../actionTypes";
import envManager from "../../com/envManager/EnvManager";
import axios from "axios";
import {Action as ProgressPopupActions} from "../actions/uploadingImagesProgressActions";
import {FlyersState} from "../reducers/flyersReducer";
import {Action as FlyerDetailsActions} from "../actions/flyerDetailsActions";
import {Action as FlyersActions} from "../actions/flyersActions";

export const createFlyerFromJpegFiles = (
    files: File[],
    uniformPageImageDimension: number = 0,
    flyersState?: FlyersState,
) => {
    let userDtoStr = localStorage.getItem("userDto");
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (
        dispatch: Dispatch<FlyerFromJpegsActions | ProgressPopupActions | FlyerDetailsActions | FlyersActions>
    ) => {
        dispatch({
            type: ActionType.CREATE_FLYER_FROM_JPEGS_START,
        });

        try {
            let result: any = await createFlyerFromJpegFilesRequest(
                files,
                uniformPageImageDimension,
                dispatch
            );
            // dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            let flyer = result.data.data.flyer;
            dispatch({
                type: ActionType.CREATE_FLYER_FROM_JPEGS_SUCCESS,
                payload: flyer.flyRecId,
            });
            // dispatch({
            //     type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
            //     payload: flyer,
            // });
            if (flyersState) {
                const flyersStatePayload: FlyersState = {
                    ...flyersState,
                    flyers: [flyer, ...flyersState.flyers],
                };
                dispatch({
                    type: ActionType.FLYER_DETAILS_DATA_CHANGE_EVENT,
                    payload: flyer,
                });

                dispatch({
                    type: ActionType.CHANGE_FLYERS_STATE,
                    payload: flyersStatePayload,
                });
            }
            localStorage.removeItem(`userEnterForFirstTime${userDto.userId}`);
            dispatch({
                type: ActionType.CREATE_FLYER_FROM_JPEGS_COMPLETED
            });
        } catch (err) {
            // dispatch({type: ActionType.CLEAR_UNLINK_PROMOS_ITEMS_FROM_MENU});
            dispatch({
                type: ActionType.UPLOAD_IMAGES_PROGRESSBAR_POPUP_ERROR
            })
            dispatch({
                type: ActionType.CREATE_FLYER_FROM_JPEGS_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err),
            });
        }
    };
};


const createFlyerFromJpegFilesRequest = (
    files: File[],
    uniformPageImageDimension: number,
    dispatch: Dispatch<FlyerFromJpegsActions | ProgressPopupActions>
) => {
    return new Promise(async (resolve, reject) => {
        try {
            let userDtoStr = localStorage.getItem("userDto");
            let userDto: UserDto = JSON.parse(userDtoStr!);
            const formData = new FormData();
            files.forEach((file: File) => {
                formData.append(`Jpegs`, file, file.name);
            });
            formData.append("UniformPageImageDimension", uniformPageImageDimension.toString());

            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + userDto.token,
                },
                onUploadProgress: (progressEvent: any) => {
                    const percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    // console.log(percentCompleted);
                    const data: UploadProgressingImagesDto = {
                        isUploadingFilesToSystem: progressEvent.loaded !== progressEvent.total,
                        isUploadingFilesToSystemFinished: progressEvent.loaded === progressEvent.total,
                        current: progressEvent.loaded === progressEvent.total ? 0 : progressEvent.loaded,
                        failCount: 0,
                        processingFinished: false,
                        successCount: 0,
                        severityLevel: '',
                        total: progressEvent.loaded === progressEvent.total ? 0 : progressEvent.total,
                        titlePopup: `Uploading file...`,
                        notUploadedImages: null,
                    }
                    dispatch({
                        type: ActionType.UPLOAD_IMAGES_PROGRESSBAR_POPUP_CHANGE,
                        payload: data
                    });
                },

            };
            // data will contain fresh FlyerDto data
            let url = `${envManager.flyerEditorServerAddress}/api/Flyers/CreateFlyerFromJpegs`;
            let result: any = await axios.post(url, formData, config);

            resolve(result);
        } catch (e) {
            reject(e);
        }
    });
};


